import React, { FC } from "react";

import { IFilterItem } from "@/shared/contexts/localFilterContext";
import { useLocalFilter } from "@/shared/hooks/useLocalFilter";

import SelectedFilter from "./SelectedFilter";

type LocalFilterChipListProps = {
    filters: IFilterItem[];
};

const LocalFilterChipList: FC<LocalFilterChipListProps> = ({ filters }) => {
    const { isFilterApplied, getFilterValue, removeFilter } = useLocalFilter();

    const handleFilterSelection = (filterId: string) => {
        removeFilter(filterId);
    };

    return (
        <>
            {filters
                .filter((filter) => isFilterApplied(filter.id))
                .map((f) => (
                    <SelectedFilter
                        key={`filter-${f.id}`}
                        filterId={f.id}
                        label={f.valueDisplay(getFilterValue(f.id))}
                        showRemoveIcon
                        onRemove={() => handleFilterSelection(f.id)}
                    />
                ))}
        </>
    );
};

export default LocalFilterChipList;
